import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  FetchAdChatParams,
  FetchChatChannelUserListParams,
  FetchSupporterChatNoticeParams,
} from '@module/apis/client-side/chat/type';

export const chatQueryKeys = createQueryKeys('chat', {
  postChatMessage: () => ['postChatMessage'],
  freezeChatRoom: () => ['freezeChatRoom'],
  fetchChatChannelUserList: (fetchChatChannelUserListParams: FetchChatChannelUserListParams) => [
    fetchChatChannelUserListParams,
  ],
  fetchAdChatConfig: (params: FetchAdChatParams) => [params],
  fetchSaveAdChat: () => ['saveAdChat'],
  fetchChatTranslate: () => ['chatTranslate'],
  fetchSupporterChatNotice: (params: FetchSupporterChatNoticeParams) => [params],
});
